import src from "IMAGE";
export default { src, width: 159, height: 145, blurWidth: 0, blurHeight: 0};
